import { Divider } from 'antd';
import React from 'react';
import { CSSProperties } from 'styled-components';
import styles from './style.module.scss';

type TitlePageProps = {
  text: React.ReactNode;
  subTitle?: string;
  withLine?: boolean;
  actions?: React.ReactNode;
  optionalStyles?: CSSProperties;
};

const TitlePage: React.FC<TitlePageProps> = ({ text = '<Title text here>', subTitle, withLine = false, actions, optionalStyles = {} }) => {
  return (
    <React.Fragment>
      <div className={styles['title-page-container']} style={optionalStyles}>
        <div className={styles['text-wrapper']}>
          {subTitle && <span className={styles['subtitle']}>{subTitle}</span>}
          <div className={styles['main-title-container']}>
            <h1>{text}</h1>
          </div>
        </div>
        {actions && <div className={styles['actions-container']}>{actions}</div>}
      </div>
      {withLine && <Divider className={styles['title-divider']} />}
    </React.Fragment>
  );
};

export default TitlePage;
